import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@models/order';
import { OrderForm } from '@classes/order-form';
import { StoreService } from '@services/store.service';
import { AuthService } from '@services/auth.service';
import { OrderLogDialogComponent } from '@components/admin/order/order-log-dialog/order-log-dialog.component';

@Component({
  selector: 'app-log-menu',
  templateUrl: './log-menu.component.html',
  styleUrls: ['./log-menu.component.css'],
})
export class LogMenuComponent implements OnInit {
  @Input() showLog: boolean;
  @Input() order: any;
  @Input() small: boolean = false;
  @Input() alwaysShow = false;
  @Output() clickField = new EventEmitter<boolean>();
  _order: FormGroup;

  constructor(
    public auth: AuthService,
    public storeService: StoreService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    if (!this.order.value && this.order['_id']) {
      this._order = OrderForm.initOrderFormGroup(
        this.order as Order,
        this.auth,
        this.storeService.stores
      );
    } else {
      this._order = this.order as FormGroup;
    }
  }

  ngAfterViewInit() {}

  get hasLogs(): boolean {
    return this.logs.length > 0;
  }

  get logs() {
    const source = this.order?.value ? this.order : this._order;
    return source?.value?.log || [];
  }

  openLog($event?: Event): void {
    $event?.preventDefault();
    $event?.stopPropagation();
    this.clickField.emit(true);
    const source = this.order?.value ? this.order : this._order;
    const value = source?.value || this.order || {};
    const patient = value.patient;
    const patientId =
      (typeof patient === 'object' && patient?._id) || patient || null;
    this.dialog.open(OrderLogDialogComponent, {
      width: '560px',
      autoFocus: false,
      panelClass: 'order-log-dialog-panel',
      data: {
        logs: this.logs,
        invoiceNumber: value.invoiceNumber,
        orderId: value._id,
        patientId,
      },
    });
  }
}
